export default __webpack_public_path__ + "static/media/copy_icon.22fabed7.svg";